<template>
	<div class="page-layout" v-loading="loading">
		<gc-header headerData="alarmNoticeRecords"></gc-header>
		<div class="run-main">
			<div class="serach">
				<gc-advanced-filter
					v-model="form"
					:fields="filterFields"
					@search="handleFilterSearch"
					@reset="handleFilterReset"
				/>
				<gc-column-setting
					:storageKey="`localcolumn-alarm-notice-records`"
					:columns="columns"
					@update-column="data => (columns = data)"
				></gc-column-setting>
			</div>
			<div class="table-show">
				<gc-table
					:columns="columnList"
					:table-data="tableData"
					:border="true"
					:showPage="true"
					:total="page.total"
					:page-size="page.size"
					:currentPage="page.current"
					@current-page-change="
						currentPage => {
							currentPageChange(currentPage, apiGetAlarmNoticeList, 'create')
						}
					"
					@size-change="
						size => {
							page.size = size
							currentPageChange(1, apiGetAlarmNoticeList, 'create')
						}
					"
				></gc-table>
			</div>
		</div>
	</div>
</template>

<script>
import { apiGetAlarmNoticeList } from '@/apis/alarm.api.js'
import common from '../mixins/common.js'
import { nameTrans } from '@/utils/index.js'

export default {
	name: 'alarmNoticeRecords',
	mixins: [common],
	data() {
		return {
			form: {
				time: null,
				notifyType: null,
			},
			columns: [
				{
					key: 'createTime',
					name: '推送时间',
					width: 170,
				},
				{
					key: 'sendStatus',
					name: '推送状态',
					width: 170,
					render: (h, row) => {
						return h('span', {}, nameTrans(row.sendStatus, this.sendStatusOptions))
					},
				},
				{
					key: 'sendContent',
					name: '内容',
				},
				{
					key: 'receiveName',
					name: '接收人',
					width: 170,
				},
				{
					key: 'notifyType',
					name: '推送渠道',
					width: 170,
					render: (h, row) => {
						return h('span', {}, nameTrans(row.notifyType, this.notifyType))
					},
				},
			],
		}
	},
	computed: {
		notifyType() {
			return this.$store.getters.dataList.notifyType || []
		},
		sendStatusOptions() {
			return this.$store.getters.dataList.sendStatus || []
		},
		columnList() {
			return this.columns.filter(o => o.selected)
		},
		filterFields() {
			return [
				{
					prop: 'time',
					label: '通知时间区间',
					type: 'date',
					props: {
						datePickerType: 'datetimerange',
					},
				},
				{
					prop: 'notifyType',
					label: '推送渠道',
					type: 'select',
					props: {
						searchOption: this.notifyType,
						searchOptionKey: { label: 'name', value: 'defaultValue' },
						needAllForSearch: true,
					},
				},
			]
		},
	},
	mounted() {
		this.getList(1, apiGetAlarmNoticeList, 'create')
	},
	methods: {
		apiGetAlarmNoticeList,
		handleFilterSearch() {
			this.getList(1, apiGetAlarmNoticeList, 'create')
		},
		handleFilterReset() {
			this.getList(1, apiGetAlarmNoticeList, 'create')
		},
	},
}
</script>
<style lang="scss" scoped>
@import '../runLayout.scss';
</style>
